<script setup lang="ts">
import { computed, onErrorCaptured, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useAppStore } from '@/store/modules/app'
import { ConfigGlobal } from '@/components/ConfigGlobal'
import { useDesign } from '@/hooks/web/useDesign'

const { getPrefixCls } = useDesign()

const prefixCls = getPrefixCls('app')

const appStore = useAppStore()
const route = useRoute()

const currentSize = computed(() => appStore.getCurrentSize)

const greyMode = computed(() => appStore.getGreyMode)

/** Grayscale filter breaks third-party iframes (e.g. Google Sign-In); skip on login. */
const routerViewClass = computed(() => {
  if (route.path === '/login') return ''
  return greyMode.value ? `${prefixCls}-grey-mode` : ''
})

appStore.initTheme()

// 全局错误捕获
onErrorCaptured((err, instance, info) => {
  console.error('❌ [App Error Captured]')
  console.error('Error:', err)
  console.error('Error info:', info)
  console.error('Component:', instance?.$options?.name || instance?.$?.type?.name || 'Unknown')
  console.error('Stack:', err.stack)

  // 返回 false 阻止错误继续传播
  return false
})

onMounted(() => {
  console.log('✅ [App] App component mounted successfully')
  console.log('[App] Current route:', window.location.hash)
})
</script>

<template>
  <ConfigGlobal :size="currentSize">
    <RouterView :class="routerViewClass" />
  </ConfigGlobal>
</template>

<style lang="less">
@prefix-cls: ~'@{adminNamespace}-app';

.size {
  width: 100%;
  height: 100%;
}

html,
body {
  padding: 0 !important;
  margin: 0;
  overflow: hidden;
  .size;

  #app {
    .size;
  }
}

.@{prefix-cls}-grey-mode {
  filter: grayscale(100%);
}
</style>
